import { createSlice } from "@reduxjs/toolkit";
import {
  getOrders,
  getCustomerOrders,
  getSupplierOrderById,
  changeOrderStatus,
  addNewOrder,
  updateOrder,
  purchaseOrder,
  cancelSupplierOrder,
  cancelCustomerOrder,
  offerUnits,
  orderShipped,
} from "./thunk";
import { toast } from "react-toastify";
import { useSyncExternalStore } from "react";

export const initialState = {
  orders: [],
  customerOrders: [],
  error: {},
  order: null,
  loading: false,
  pagination: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    total: 0,
    totalActive: 0,
    totalCancelled: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalInStock: 0,
    totalInactive: 0,
    totalOrdered: 0,
    totalOutOfStock: 0,
    totalPendingOrders: 0,
    totalReady: 0,
    totalStockNotifications: 0,
  },
  orderPlaced: false,
  orderCancelled: false,
};

const OrdersSlice = createSlice({
  name: "OrdersSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getOrders.pending, (state, action) => {
      state.loading = true;
      state.orders = [];
      state.error = {};
    });

    builder.addCase(getOrders.fulfilled, (state, action) => {
      state.orders = action.payload.data;
      state.pagination = action.payload.pagination;
      state.loading = false;
    });

    builder.addCase(getOrders.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(changeOrderStatus.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Changing Order Status...", {
        position: "top-center",
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(changeOrderStatus.fulfilled, (state, action) => {
      const index = state.orders.findIndex(
        (order) => order.suoId === action.payload.data.suoId
      );
      if (index !== -1) {
        state.orders[index] = {
          ...state.orders[index],
          suoStatus: action.payload.data.suoStatus,
        };
      }
      state.orderPlaced = true;
    });

    builder.addCase(changeOrderStatus.rejected, (state, action) => {
      // state.error = action.payload.error || null;
      toast.dismiss();
      toast.error("Order Status Change Failed ", {
        position: "top-center",
        autoClose: 3000,
      });
    });

    builder.addCase(getCustomerOrders.pending, (state, action) => {
      state.loading = true;
      state.customerOrders = [];
      state.error = {};
    });

    builder.addCase(getCustomerOrders.fulfilled, (state, action) => {
      state.customerOrders = action.payload.data;
      state.pagination = action.payload.pagination;
      state.loading = false;
    });

    builder.addCase(getCustomerOrders.rejected, (state, action) => {
      //state.error = action.payload.error || null;
    });

    builder.addCase(getSupplierOrderById.fulfilled, (state, action) => {
      state.orderPlaced = false;
      state.order = action.payload.data;
      state.orderPlaced = true;
    });

    builder.addCase(addNewOrder.fulfilled, (state, action) => {
      toast.dismiss();
      toast.loading("Updating Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orders.push(action.payload);
    });

    builder.addCase(addNewOrder.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addNewOrder.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Adding Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(updateOrder.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(updateOrder.fulfilled, (state, action) => {
      const index = state.orders.findIndex(
        (order) => order.ord_id === action.payload.ord_id
      );
      state.orders[index] = action.payload.data;
    });

    builder.addCase(updateOrder.rejected, (state, action) => {
      toast.error("Order Updateded Failed ", {
        position: "top-center",
        autoClose: 3000,
      });
      //state.error = action.payload.error || null;
    });

    builder.addCase(offerUnits.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Sending Email...", {
        position: "top-center",
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(offerUnits.fulfilled, (state, action) => {});

    builder.addCase(offerUnits.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });

    builder.addCase(purchaseOrder.fulfilled, (state, action) => {
      if (action.payload?.success) {
        toast.dismiss();
        toast.success("Order Purchased Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
        state.orderPlaced = true;

        state.orders = state.orders.map((order) =>
          order.suo_id === action.payload.data.suo_id
            ? action.payload.data
            : order
        );
      } else {
        toast.dismiss();
        toast.error(action.payload?.message || "Order Purchase Failed.", {
          position: "top-center",
          autoClose: false,
          closeOnClick: true,
          closeButton: true,
        });
      }
    });

    builder.addCase(purchaseOrder.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Purchasing Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(purchaseOrder.rejected, (state, action) => {
      //state.error = action.payload.error || null;
    });

    builder.addCase(orderShipped.fulfilled, (state, action) => {
      state.orderPlaced = false;
      toast.dismiss();
      toast.loading("Order shipped", {
        position: "top-center",
        autoClose: false,
      });
      /*
      state.orders = state.orders.map((order) =>
        order.suo_id === action.payload.data.suo_id
          ? action.payload.data
          : order
      );
      */
      state.orderPlaced = true;
    });
    builder.addCase(orderShipped.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(orderShipped.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Shipping Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(cancelSupplierOrder.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Cancelling Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(cancelSupplierOrder.fulfilled, (state, action) => {
      toast.dismiss();
      toast.loading("Order cancelled", {
        position: "top-center",
        autoClose: false,
      });
      state.orderCancelled = true;
      const index = state.orders.findIndex(
        (order) => order.suoId === action.payload.data.suo_id
      );
      if (index !== -1) {
        state.orders[index] = {
          ...state.orders[index],
          suoStatus: action.payload.data.suo_status,
        };
      }
    });

    builder.addCase(cancelSupplierOrder.rejected, (state, action) => {
      //state.error = action.payload.error || null;
    });

    builder.addCase(cancelCustomerOrder.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Cancelling Order...", {
        position: "top-center",
        autoClose: false,
      });
      state.orderPlaced = false;
      state.orderCancelled = false;
      state.error = {};
    });

    builder.addCase(cancelCustomerOrder.fulfilled, (state, action) => {
      toast.dismiss();
      toast.loading("Order cancelled", {
        position: "top-center",
        autoClose: false,
      });
      state.orderCancelled = true;
      const index = state.customerOrders.findIndex(
        (order) => order.ord_id === action.payload.data.ordId
      );
      if (index !== -1) {
        state.customerOrders[index] = {
          ...state.customerOrders[index],
          ord_status: action.payload.data.ordStatus,
        };
      }

      const orderIndex = state.orders.findIndex(
        (order) => order.suoId === action.payload.data.ordSuoId
      );

      if (orderIndex !== -1) {
        //const ordIndex = state.orders[orderIndex].orders.findIndex((order) => order.ordId === action.payload.data.ordId);
        const ordSupp = state.orders[orderIndex];

        state.orders[orderIndex] = {
          ...ordSupp,
          orders: ordSupp.orders.map((order) =>
            order.ordId === action.payload.data.ordId
              ? { ...order, ordStatus: action.payload.data.ordStatus }
              : order
          ),
        };
      }
    });

    builder.addCase(cancelCustomerOrder.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  },
});

export default OrdersSlice.reducer;
